export const doUpdateUserPv = (userId, state) => {
    return {
        type: 'PVUSER_SET_STATE',
        payload: state,
        userId: userId
    };
};
